var getValidationRules = function (t) {

  return {
    rules: {
      email: {
        required: true,
        maxlength: 100,
        email: true
      }
    },

    messages: {
      email: {
        required: t('Please enter %s', {
          context: 'validation',
          postProcess: 'sprintf',
          sprintf: [t('Email')]
        }),
        maxlength: t('Max length of %s is %d characters', {
          context: 'validation',
          postProcess: 'sprintf',
          sprintf: [t('Email'), 100]
        }),
        email: t('Please enter a valid email address.', {context: 'validation'})
      }
    },

    errorPlacement: function (error, element) {
      error.insertAfter(element);
    }
  }

};


module.exports = getValidationRules;
